import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/ProductView.vue')
  },

  {
    path: '/service',
    name: 'service',
    component: () => import('../views/ServiceView.vue')
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('../views/CaseView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/product/database-audit',
    name: 'database-audit',
    component: () => import('../views/product/DatabaseAudit.vue')
  },
  {
    path: '/product/ops-security',
    name: 'ops-security',
    component: () => import('../views/product/OpsSecurity.vue')
  },
  {
    path: '/product/ai-ops-platform',
    name: 'ai-ops-platform',
    component: () => import('../views/product/AiOpsPlatform.vue')
  },
    {
    path: '/product/biosample-mgmt',
    name: 'biosample-mgmt',
    component: () => import('../views/product/BiosampleMgmt.vue')
  },
      {
    path: '/product/auto-ops-resource',
    name: 'auto-ops-resource',
    component: () => import('../views/product/AutoOpsResource.vue')
  }, 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有 savedPosition（浏览器前进/后退按钮），则恢复到之前的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到顶部
    return { top: 0 }
  }
})



export default router
